import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPurpleFolders = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 6,
			fill: "#DEDBFF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			transform: "translate(12 12)",
			fill: "#DEDBFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17 16C16.4477 16 16 16.4477 16 17V18H22.382L21.6584 16.5528C21.489 16.214 21.1427 16 20.7639 16H17ZM24.618 18L23.4472 15.6584C22.939 14.642 21.9002 14 20.7639 14H17C15.3431 14 14 15.3431 14 17V31C14 32.6569 15.3431 34 17 34H31C32.6569 34 34 32.6569 34 31V21C34 19.3431 32.6569 18 31 18H24.618ZM23.9799 20C23.9938 20.0003 24.0077 20.0003 24.0217 20H31C31.5523 20 32 20.4477 32 21V31C32 31.5523 31.5523 32 31 32H17C16.4477 32 16 31.5523 16 31V20H23.9799Z",
			fill: "#534ABA"
		})
	]
});
export default SvgPurpleFolders;
